import {Component} from "react";
import * as React from "react";

export class MainPage extends Component {
    public render() {
        return (
            <div></div>
        );
    }
}